<template>
  <form @submit.prevent="save">
    <div class="card">
      <div class="card-body add-product pb-0">
        <div class="row">
          <div class="mb-3 add-product">
            <label class="form-label">Product Code</label>
            <input
              v-model="form.productcode"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': errors.productcode }"
              readonly
            >
            <div v-if="errors.productcode" class="invalid-feedback">
              {{ errors.productcode[0] }}
            </div>
          </div>

          <div class="mb-3 add-product">
            <label class="form-label">Product Name</label>
            <input
              v-model="form.name"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': errors.name }"
              placeholder="Enter product name"
            >
            <div v-if="errors.name" class="invalid-feedback">
              {{ errors.name[0] }}
            </div>
          </div>

          <div class="mb-3 add-product">
            <label class="form-label">Description</label>
            <input
              v-model="form.description"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': errors.description }"
              placeholder="Enter product description"
            >
            <div v-if="errors.description" class="invalid-feedback">
              {{ errors.description[0] }}
            </div>
          </div>

          <div class="input-blocks add-product">
            <label>Cost</label>
            <input
              v-model.number="form.cost"
              type="number"
              class="form-control"
              :class="{ 'is-invalid': errors.cost }"
              step="0.01"
              min="0"
              placeholder="0.00"
            >
            <div v-if="errors.cost" class="invalid-feedback">
              {{ errors.cost[0] }}
            </div>
          </div>

          <div class="input-blocks add-product">
            <label>Price</label>
            <input
              v-model.number="form.price"
              type="number"
              class="form-control"
              :class="{ 'is-invalid': errors.price }"
              step="0.01"
              min="0"
              placeholder="0.00"
            >
            <div v-if="errors.price" class="invalid-feedback">
              {{ errors.price[0] }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer-btn">
      <button type="button" class="btn btn-cancel me-2" data-bs-dismiss="modal">Cancel</button>
      <button type="submit" class="btn btn-submit" :disabled="loading">
        <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
        Create
      </button>
    </div>
  </form>
</template>

<script>
import { showSuccessMessage, showErrorMessage } from '../utils/notifications.js';

export default {
  name: 'ProductCreate',

  data() {
    return {
      form: {
        productcode: '',
        name: '',
        description: '',
        cost: 0,
        price: 0
      },
      errors: {},
      loading: false
    };
  },

  async mounted() {
    console.log('ProductCreate component mounted');

    // Generate product code on mount
    await this.generateProductCode();

    // Mark element as mounted
    this.$el.closest('[data-vue-component]')?.classList.add('vue-mounted');
  },

  methods: {
    async generateProductCode() {
      try {
        const response = await this.$http.get('/api/products/generate-code');
        if (response.data.success) {
          this.form.productcode = response.data.product_code;
        }
      } catch (error) {
        console.error('Failed to generate product code:', error);
        this.showErrorMessage('Failed to generate product code');
      }
    },

    async save() {
      this.loading = true;
      this.errors = {};

      try {
        const response = await this.$http.post('/api/products', this.form);

        if (response.data.success) {
          this.showSuccessMessage(response.data.message);

          // Reset form
          this.resetForm();

          // Close modal
          const modal = this.$el.closest('.modal');
          if (modal) {
            const modalInstance = bootstrap.Modal.getInstance(modal);
            if (modalInstance) {
              modalInstance.hide();
            }
          }

          // Emit event for parent components
          this.$emit('product-created', response.data.product);

          // Redirect if specified
          if (response.data.redirect_url) {
            window.location.href = response.data.redirect_url;
          } else {
            // Refresh page to show new product
            window.location.reload();
          }
        }
      } catch (error) {
        console.error('Product creation failed:', error);

        if (error.response?.status === 422) {
          this.errors = error.response.data.errors || {};
          this.showErrorMessage('Please check the form for errors');
        } else {
          this.showErrorMessage(
            error.response?.data?.message || 'An error occurred while creating the product'
          );
        }
      } finally {
        this.loading = false;
      }
    },

    resetForm() {
      this.form = {
        productcode: '',
        name: '',
        description: '',
        cost: 0,
        price: 0
      };
      this.errors = {};

      // Generate new product code
      this.generateProductCode();
    },

    showSuccessMessage,
    showErrorMessage
  }
}
</script>

<style scoped>
.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
}

.is-invalid {
  border-color: #dc3545;
}

.invalid-feedback {
  display: block;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875rem;
  color: #dc3545;
}
</style>
